import React from "react";
import UlLi, { scrollTo, mountCode, initDeepLinkData, urlChangeHandler} from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Table, Label, Glyphicon} from "react-bootstrap";
import { Navigation, Link } from "react-router";
import SDKSidebar from "js/utilities/sdk-sidebar"
import { ZOOM_ICON } from "js/config.jsx";
import CodeBlocks from "js/utilities/sdk-doc-code-blocks";


export default React.createClass({
  displayName: "zoom-docker-help",
  scrollToGuide : null,
  scrollingEl : null,
  getInitialState: function() {
    var scrollToElement = initDeepLinkData(this.props);
    return {
      scrollToElement: scrollToElement
    };
  },

  componentDidMount: function() {
    mountCode(this);
  },

  componentWillMount() {
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },

  render: function() {

    if (this.scrollToGuide && this.scrollingEl)
      scrollTo(this.scrollingEl, this.scrollToGuide);
    this.scrollToGuide = null;

    return (
      <div>
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container zoom_docker">

              <section>
                <div className="title">
                  <Glyphicon glyph="list" />
                  <h2 id="zoom-server-quickstart">FaceTec Custom Server Quickstart</h2>
                </div>
                <p>This guide steps through the initial development steps to get the FaceTec Custom Server SDKs running locally on your dev machine and in your cloud.</p>
                <hr/>
              </section>

              <section>
                <h3 id="getting-started">Getting Started</h3>
                <p>This guide is meant to get you up and running quickly via the FaceTec Server Custom Dockerized SDK.  To deploy via some other method, or to use the FaceTec Server Core SDK or FaceTec Server REST Sample Code, we still recommend checking out the contents of the FaceTec Server SDK Dockerized SDK.  The scope of this integration guide includes getting up and running, testing FaceTec Server, and initial deployment steps.</p>
                <br/>
                <hr/>
              </section>

              <section>
                <h3 id="prerequisites">Prerequisites</h3>
                <p>You will need to download, and install <a href="https://www.docker.com/" target="_blank">Docker</a></p>
                <p><strong>Windows Users</strong>:  You will need to make sure your Shared Drives are configured correctly. This usually means you just need to allow access to your C drive. Please see the <a href="https://docs.docker.com/docker-for-windows/#shared-drives" target="_blank">Docker Guides</a> for more information.</p>
                <br/>
                <hr/>
              </section>

              <section>
                <h3 id="deploying-zoom-server-and-browser-locally-video-tutorial">Deploying FaceTec Custom Server SDKs & Browser Locally (Video Tutorial)</h3>
                <p><strong>In the videos</strong>: We also show starting up, running, and performing Liveness Checks using the FaceTec Browser SDK via Docker.  Downloading and running the FaceTec Browser SDK like this is a fast and easy way to verify that your FaceTec Server SDK is functioning correctly.</p>
                <h5>Starting the FaceTec Server Custom Dockerized SDK (Initial Development)</h5>
                <p><iframe width="560" height="315" src="https://www.youtube.com/embed/BFBH8Obq7Ag" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe></p>

                <h5>Starting the FaceTec Server Custom Dockerized SDK (with Production Key and Custom FaceMap Encryption Key)</h5>
                <p><iframe width="560" height="315" src="https://www.youtube.com/embed/JVrAfpUVZRQ" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe></p>
                <p></p>
                <p></p>

                <hr/>
              </section>

              <section>
                <h3 id="how-does-it-work">How does it work?</h3>
                <p>In the above videos, we start up one container for the FaceTec Server Custom Dockerized SDK and one container for the FaceTec Browser SDK.  The FaceTec Server Custom Dockerized SDK starts a server with <Link to="/zoom-server-rest-api">REST endpoints</Link> on your local dev machine.  The FaceTec Browser SDK Docker container serves the Sample App on localhost and sends requests to the localhost deployment of the FaceTec Server Custom Dockerized SDK.</p>
                <p>In this setup, <strong>you are creating a small, containerized version of the entire FaceTec platform</strong> right on your own dev machine!</p>
                <hr/>
              </section>

              <section>
                <h3 id="deploying-zoom-server-and-browser-locally-initial-development">Running FaceTec Server & Browser Locally (Initial Development)</h3>
                <p>The below commands show how to run the FaceTec Server Custom Dockerized SDK using your initial development SDK Keys.  To run, you just need to cd to the extracted directory and run one command (inserting your Key  information).</p>
                <h4>Step 1 - Run the FaceTec Server Custom Dockerized SDK</h4>
                <p>Start the FaceTec Server Custom Dockerized SDK locally on your dev machine.</p>
                <div className="highlight">
                    # From the extracted FaceTec Server Custom Dockerized SDK directory...<br/>
                    docker-compose build --build-arg DeviceLicenseKeyIdentifier=[YOUR_DEVICE_LICENSE_KEY] --build-arg ServerLicenseKeyIdentifier=[YOUR_SERVER_LICENSE_KEY] --build-arg PathToPrivateKeyForFaceMapEncryptionFile=./keys/PrivateFaceMapEncryptionKey.pem && docker-compose up
                </div>
                <h4>Step 2 - Run the FaceTec Browser SDK (Pointed at FaceTec Testing API)</h4>
                <p>Test the Browser SDK while pointed at the FaceTec Testing API.</p>
                <div className="highlight">
                    # From the extracted FaceTec Server Custom Dockerized SDK directory...<br/>
                    docker-compose build --build-arg DeviceLicenseKeyIdentifier=[YOUR_DEVICE_LICENSE_KEY] --build-arg ZoomServerBaseURL=https://api.zoomauth.com/api/v2/biometrics --build-arg PathToPublicFaceMapEncryptionKey=./keys/PublicFaceMapEncryptionKey.pub && docker-compose up
                </div>
                <h4>Step 3 - Run the FaceTec Browser SDK (Pointed at local FaceTec Server Custom Dockerized SDK)</h4>
                <p>Finally, re-launch the Browser SDK while configuring it to use your local FaceTec Server rather than the FaceTec Testing API.</p>
                <div className="highlight">
                    # From the extracted FaceTec Server Custom Dockerized SDK directory...<br/>
                    docker-compose build --build-arg DeviceLicenseKeyIdentifier=[YOUR_DEVICE_LICENSE_KEY] --build-arg ZoomServerBaseURL=http://localhost:8080 --build-arg PathToPublicFaceMapEncryptionKey=./keys/PublicFaceMapEncryptionKey.pub && docker-compose up
                </div>
                <br/>
              </section>

              <hr />

              <section>
                <h3 id="deploying-zoom-server-and-browser-locally">Running FaceTec Server Custom Dockerized SDK & Browser Locally (with Production Key and Custom FaceMap Encryption Key)</h3>
                <p>To run FaceTec Server and FaceTec Browser locally using a <Link to="/licensing">Production Key</Link> and <Link to="/facemap-encryption-keys">Custom FaceMap Encryption Key</Link>, there are a few more parameters you need to add and/or change.  See the below commands for examples.</p>
                <h4>Step 1 - Run the FaceTec Server Custom Dockerized SDK</h4>
                <p>Start the FaceTec Server Custom Dockerized SDK (using a Production Key and Custom FaceMap Encryption Key) locally on your dev machine.</p>
                <div className="highlight">
                    # From the extracted FaceTec Server Custom Dockerized SDK directory...<br/>
                    docker-compose build --build-arg DeviceLicenseKeyIdentifier=[YOUR_DEVICE_LICENSE_KEY] --build-arg ServerLicenseKeyIdentifier=[YOUR_SERVER_LICENSE_KEY] --build-arg PathToPrivateKeyForFaceMapEncryptionFile=./keys/PrivateFaceMapEncryptionKey.pem --build-arg PathToSFTPLicenseFile=./keys/FaceTec_Server_License.txt && docker-compose up
                </div>
                <h4>Step 2 - Run the FaceTec Browser SDK (Pointed at local FaceTec Server Custom Dockerized SDK)</h4>
                <p>Start the Browser SDK (using a Production Key and Custom FaceMap Encryption Key) while configuring it to use your local FaceTec Server rather than the FaceTec Testing API.</p>
                <div className="highlight">
                    # From the extracted FaceTec Server Custom Dockerized SDK directory...<br/>
                    docker-compose build --build-arg DeviceLicenseKeyIdentifier=YOUR_DEVICE_LICENSE_KEY --build-arg ZoomServerBaseURL=https://api.zoomauth.com/api/v2/biometrics --build-arg PathToPublicFaceMapEncryptionKey=./keys/PublicFaceMapEncryptionKey.pub --build-arg PathToSFTPLicenseText=./keys/FaceTec_Browser_SDK_License.txt && docker-compose up
                </div>
                <br/>
              </section>

              <hr />

              <section>
                <h3 id="aws-deployment">AWS Deployment</h3>
                <p>The steps in the previous sections demonstrate deployment to any machine.  If you are using AWS, we recommend using an EB cluster for your FaceTec Server Custom Dockerized SDK instances.</p>

                <h5>Configuration</h5>
                <p>You will need to install and configure:</p>
                <ul>
                  <li><p><a href="https://docs.aws.amazon.com/cli/latest/userguide/cli-chap-install.html" target="_blank">AWS CLI</a></p></li>
                  <li><p><a href="https://docs.aws.amazon.com/elasticbeanstalk/latest/dg/eb-cli3-install.html#eb-cli3-install.scripts" target="_blank">EB CLI</a></p></li>
                </ul>


                <p>Initialize Elastic Beanstalk Application</p>
                <div className="highlight">
                  eb init<br/><br/>

                  ## Follow onscreen prompts ##<br/><br/>

                  It appears you are using Docker. Is this correct?<br/>
                  (Y/n): Y<br/><br/>

                  ## Follow onscreen prompts ##
                </div>

                <p>Deploy to Elastic Beanstalk</p>
                <div className="highlight">
                  # Make sure to replace your SDK Keys in the following command.
                  eb create MY_APPLICATION_NAME -i c5.2xlarge --cname MY_APPLICATION_SUBDOMAIN --envvars DeviceLicenseKeyIdentifier=YOUR_DEVICE_LICENSE_KEY,ServerLicenseKeyIdentifier=YOUR_DEVICE_SERVER_KEY
                </div>
                <br/>
              </section>

              <section>
                <h3 id="docker-notes">A Note on Docker Support</h3>
                <p>The FaceTec Server Custom Dockerized SDK is a <strong>Linux Container</strong>.</p>
                <p>In development, the FaceTec SDK Linux Container runs on Mac, Linux, or Windows 10 Pro/Enterprise -- all via Docker.</p>
                <p>In production, FaceTec recommends running FaceTec Linux Containers on a Linux Host.  AWS, Google Cloud, and Azure support numerous methods of deployment of Linux Containers. For custom/private Linux deployments, a basic deployment can be configured using the same steps as running in development.</p>
                <p>Although Linux Hosts are strongly recommended, if Windows Hosts are an absolute requirement, Linux Containers can be ran on Windows Server 2016, 2019, and systems that support <a href="https://techcommunity.microsoft.com/t5/windows-server-insiders/how-to-install-wsl-2-on-windows-server/m-p/858359" target="_blank">WSL 2</a>.</p>
              </section>

              <hr />

              <section>
                <h3 id="final-steps">Final Steps - Securing Your Deployment</h3>
                <p>FaceTec SDKs are deployed into many very large organizations, banks, financial institutions, governments, and more.  Most large entities have specific and highly varying security requirements, philosophies, and levels of sophistication.  The FaceTec Device & Server SDKs provide a high degree of flexibility in terms of server-side app architecture.</p>
                <p>FaceTec currently requires Customers & Partners to handle the transfer of the FaceMap, Audit Trail Images, and any other FaceTec-related data using your Application's pre-existing, already-vetted, blessed-by-your-security-team's communication channels from your secure application code to your server.</p>
                <p>Once the FaceMap and Audit Trail data is into your secure server environment, you will be calling the REST endpoints created by this deployment using a secure, server-to-server HTTPS call.</p>
                <p>In the future, while we will still offer ultra-flexible deployment mechanisms, our default SDK will be changing to become more turnkey and prescriptive by default, requiring less configuration, and implementing all recommended features by default, without the ability to turn them off.</p>
                <p>For more information about integration, security, and deployment, see the <Link to="security-best-practices">Security Best Practices Guide</Link>, <Link to="/server-integration">Server Integration Guide</Link>, and <Link to="/zoom-server-rest-api">FaceTec Server REST API Reference</Link>.</p>
              </section>

              <SDKSidebar menuType="main" title="FaceTec Docker Help"/>

            </div>
          </div>
        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/zoom-docker-help.jsx